import { RgChildren as a, getRgObjectsOfType as t, RG_TYPE as u } from "@project-rouge/rg-core";
function g(d, i) {
  i = i ?? a.Building;
  const s = t(d, u.Building), l = [];
  for (const n of s) {
    const r = n.data.levels.filter((e) => !e.isPodium && !e.isRoof).map((e) => e.levelIndex), o = i.flatMap((e) => t(n, e)).filter((e) => r.includes(e.data.level));
    l.push(...o);
  }
  return l;
}
export {
  g as getBuildingChildrenAtResidentialLevels
};
//# sourceMappingURL=index2.js.map
